(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8604],{

/***/ 23887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ Image2; },
/* harmony export */   "Ei": function() { return /* binding */ Img; }
/* harmony export */ });
/* unused harmony exports shouldShowFallbackImage, useImage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44040);
// ../../../react-shim.js


// src/image.tsx


// ../../utilities/object-utils/src/index.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone)
      delete clone[key];
  }
  return clone;
}

// src/use-image.ts


function useImage(props) {
  const {
    loading,
    src,
    srcSet,
    onLoad,
    onError,
    crossOrigin,
    sizes,
    ignoreFallback
  } = props;
  const [status, setStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("pending");
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setStatus(src ? "loading" : "pending");
  }, [src]);
  const imageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const load = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (!src)
      return;
    flush();
    const img = new Image();
    img.src = src;
    if (crossOrigin)
      img.crossOrigin = crossOrigin;
    if (srcSet)
      img.srcset = srcSet;
    if (sizes)
      img.sizes = sizes;
    if (loading)
      img.loading = loading;
    img.onload = (event) => {
      flush();
      setStatus("loaded");
      onLoad == null ? void 0 : onLoad(event);
    };
    img.onerror = (error) => {
      flush();
      setStatus("failed");
      onError == null ? void 0 : onError(error);
    };
    imageRef.current = img;
  }, [src, crossOrigin, srcSet, sizes, onLoad, onError, loading]);
  const flush = () => {
    if (imageRef.current) {
      imageRef.current.onload = null;
      imageRef.current.onerror = null;
      imageRef.current = null;
    }
  };
  (0,_chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useSafeLayoutEffect */ .G)(() => {
    if (ignoreFallback)
      return void 0;
    if (status === "loading") {
      load();
    }
    return () => {
      flush();
    };
  }, [status, load, ignoreFallback]);
  return ignoreFallback ? "loaded" : status;
}
var shouldShowFallbackImage = (status, fallbackStrategy) => status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";

// src/native-image.tsx

var NativeImage = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function NativeImage2(props, ref) {
  const { htmlWidth, htmlHeight, alt, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width: htmlWidth,
    height: htmlHeight,
    ref,
    alt,
    ...rest
  });
});
NativeImage.displayName = "NativeImage";

// src/image.tsx
var Image2 = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Image3(props, ref) {
  const {
    fallbackSrc,
    fallback,
    src,
    srcSet,
    align,
    fit,
    loading,
    ignoreFallback,
    crossOrigin,
    fallbackStrategy = "beforeLoadOrError",
    referrerPolicy,
    ...rest
  } = props;
  const providedFallback = fallbackSrc !== void 0 || fallback !== void 0;
  const shouldIgnoreFallbackImage = loading != null || ignoreFallback || !providedFallback;
  const status = useImage({
    ...props,
    ignoreFallback: shouldIgnoreFallbackImage
  });
  const showFallbackImage = shouldShowFallbackImage(status, fallbackStrategy);
  const shared = {
    ref,
    objectFit: fit,
    objectPosition: align,
    ...shouldIgnoreFallbackImage ? rest : omit(rest, ["onError", "onLoad"])
  };
  if (showFallbackImage) {
    if (fallback)
      return fallback;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
      as: NativeImage,
      className: "chakra-image__placeholder",
      src: fallbackSrc,
      ...shared
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
    as: NativeImage,
    src,
    srcSet,
    crossOrigin,
    loading,
    referrerPolicy,
    className: "chakra-image",
    ...shared
  });
});
Image2.displayName = "Image";

// src/img.tsx

var Img = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
  ref,
  as: NativeImage,
  className: "chakra-image",
  ...props
}));



/***/ }),

/***/ 44019:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
const basePath =  false || '';

function getDomainLocale(path, locale, locales, domainLocales) {
  if (true) {
    const normalizeLocalePath = (__webpack_require__(86340).normalizeLocalePath);

    const detectDomainLocale = (__webpack_require__(57565).detectDomainLocale);

    const target = locale || normalizeLocalePath(path, locales).detectedLocale;
    const domain = detectDomainLocale(domainLocales, undefined, target);

    if (domain) {
      const proto = `http${domain.http ? '' : 's'}://`;
      const finalLocale = target === domain.defaultLocale ? '' : `/${target}`;
      return `${proto}${domain.domain}${basePath}${finalLocale}${path}`;
    }

    return false;
  } else {}
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 7942:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _router = __webpack_require__(64957);

var _addLocale = __webpack_require__(57995);

var _routerContext = __webpack_require__(30647);

var _appRouterContext = __webpack_require__(51992);

var _useIntersection = __webpack_require__(90639);

var _getDomainLocale = __webpack_require__(44019);

var _addBasePath = __webpack_require__(70227);

'client';
const prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  Promise.resolve(router.prefetch(href, as, options)).catch(err => {
    if (false) {}
  });
  const curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  const {
    target
  } = event.currentTarget;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  const {
    nodeName
  } = e.currentTarget; // anchors inside an svg have a lowercase nodeName

  const isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  const navigate = () => {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow,
        locale,
        scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      const method = replace ? 'replace' : 'push';
      router[method](href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react.default.startTransition(navigate);
  } else {
    navigate();
  }
}

const Link = /*#__PURE__*/_react.default.forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var createPropError; }

  let children;

  const {
    href: hrefProp,
    as: asProp,
    children: childrenProp,
    prefetch: prefetchProp,
    passHref,
    replace,
    shallow,
    scroll,
    locale,
    onClick,
    onMouseEnter,
    onTouchStart,
    legacyBehavior = Boolean(false) !== true
  } = props,
        restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react.default.createElement("a", null, children);
  }

  const p = prefetchProp !== false;

  let router = _react.default.useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  const appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  const {
    href,
    as
  } = _react.default.useMemo(() => {
    const [resolvedHref, resolvedAs] = (0, _router).resolveHref(router, hrefProp, true);
    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]);

  const previousHref = _react.default.useRef(href);

  const previousAs = _react.default.useRef(as); // This will return the first child, if multiple are provided it will throw an error


  let child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react.default.Children.only(children);
    }
  }

  const childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;
  const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  });

  const setRef = _react.default.useCallback(el => {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react.default.useEffect(() => {
    const shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    const curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    const isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  const childProps = {
    ref: setRef,
    onClick: e => {
      if (false) {}

      if (!legacyBehavior && typeof onClick === 'function') {
        onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: e => {
      if (!legacyBehavior && typeof onMouseEnter === 'function') {
        onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: e => {
      if (!legacyBehavior && typeof onTouchStart === 'function') {
        onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    const curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    const localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react.default.cloneElement(child, childProps) : /*#__PURE__*/_react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 86340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.normalizeLocalePath = void 0;

const normalizeLocalePath = (pathname, locales) => {
  if (true) {
    return (__webpack_require__(9625).normalizeLocalePath)(pathname, locales);
  }

  return {
    pathname,
    detectedLocale: undefined
  };
};

exports.normalizeLocalePath = normalizeLocalePath;

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 90639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(67294);

var _requestIdleCallback = __webpack_require__(26286);

const hasIntersectionObserver = typeof IntersectionObserver === 'function';
const observers = new Map();
const idList = [];

function createObserver(options) {
  const id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  const existing = idList.find(obj => obj.root === id.root && obj.margin === id.margin);
  let instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  const elements = new Map();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const callback = elements.get(entry.target);
      const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id,
    observer,
    elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  const {
    id,
    observer,
    elements
  } = createObserver(options);
  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements.delete(element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers.delete(id);
      const index = idList.findIndex(obj => obj.root === id.root && obj.margin === id.margin);

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  let {
    rootRef,
    rootMargin,
    disabled
  } = _ref;
  const isDisabled = disabled || !hasIntersectionObserver;
  const [visible, setVisible] = (0, _react).useState(false);
  const [element, setElement] = (0, _react).useState(null);
  (0, _react).useEffect(() => {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        const unobserve = observe(element, isVisible => isVisible && setVisible(isVisible), {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        const idleCallback = (0, _requestIdleCallback).requestIdleCallback(() => setVisible(true));
        return () => (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  const resetVisible = (0, _react).useCallback(() => {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 51992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

const AppRouterContext = _react.default.createContext(null);

exports.AppRouterContext = AppRouterContext;

const LayoutRouterContext = _react.default.createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

const GlobalLayoutRouterContext = _react.default.createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

const TemplateContext = _react.default.createContext(null);

exports.TemplateContext = TemplateContext;

if (false) {}

/***/ }),

/***/ 48604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/index.esm.js
var transition_dist_index_esm = __webpack_require__(71197);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var icons_dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__(23887);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Logo/index.tsx




const Logo = _ref => {
  let {
    href,
    title,
    target
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
    href: href,
    target: target,
    title: title,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_dist_index_esm/* Img */.Ei, {
      src: "https://static1.carplanner.com/logos/carplanner.svg",
      alt: title,
      width: "15rem",
      height: "2.5rem",
      maxW: "15rem"
    })
  });
};

/* harmony default export */ var components_Logo = (Logo);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/OrganizationSchema/index.tsx
// src/components/OrganizationSchema.tsx




const OrganizationSchema = () => {
  const organizationData = {
    "@context": "https://schema.org/",
    "@type": "Organization",
    "name": "CarPlanner",
    "url": "https://www.carplanner.com/",
    "logo": "https://static1.carplanner.com/logos/carplanner.svg",
    "description": "CarPlanner offre soluzioni di noleggio auto a lungo termine per privati e aziende in tutta Italia.",
    "sameAs": ["https://www.facebook.com/carplannercom", "https://www.linkedin.com/company/carplanner", "https://twitter.com/CarPlannerIT"]
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(organizationData)
      }
    })
  });
};

/* harmony default export */ var components_OrganizationSchema = (OrganizationSchema);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/popover/dist/index.esm.js + 7 modules
var popover_dist_index_esm = __webpack_require__(81521);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
;// CONCATENATED MODULE: ./src/components/MenuItem/Desktop.tsx






const DesktopItem = _ref => {
  let {
    name,
    title,
    href,
    target,
    description
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
    href: href,
    title: title,
    role: "group",
    display: "block",
    p: 2,
    rounded: "md",
    target: target,
    _hover: {
      bg: 'primaryGreen.800'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
      direction: "row",
      align: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          transition: "all .3s ease",
          _groupHover: {
            color: 'baseWhite'
          },
          color: "baseNeutral.700",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.875rem",
          letterSpacing: "0.25px",
          children: name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          fontSize: "sm",
          children: description
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
        transition: "all .3s ease",
        transform: "translateX(-10px)",
        opacity: 0,
        _groupHover: {
          opacity: '100%',
          transform: 'translateX(0)'
        },
        justify: "flex-end",
        align: "center",
        flex: 1,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
          color: "baseWhite",
          w: 5,
          h: 5,
          as: icons_dist_index_esm/* ChevronRightIcon */.XC
        })
      })]
    })
  });
};

/* harmony default export */ var Desktop = (DesktopItem);
;// CONCATENATED MODULE: ./src/components/Menu/Desktop.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





/** https://github.com/chakra-ui/chakra-ui/issues/5896 */



const PopoverTrigger = popover_dist_index_esm/* PopoverTrigger */.xo;

const Desktop_Desktop = _ref => {
  let {
    items
  } = _ref;
  const {
    0: isMounted,
    1: setMount
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    setMount(true);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
    direction: "row",
    spacing: 4,
    align: "center",
    children: items.map(navItem => /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
      textAlign: "left",
      className: !isMounted && navItem.children && navItem.children.length > 0 ? 'has-popover' : '',
      children: navItem.children && navItem.children.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(popover_dist_index_esm/* Popover */.J2, {
        trigger: "hover",
        placement: "bottom-start",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PopoverTrigger, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: navItem.href,
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU // href={navItem.href}
            , {
              target: navItem.target,
              whiteSpace: "nowrap",
              color: "baseNeutral.700",
              fontFamily: "Montserrat-SemiBold",
              fontSize: "0.875rem",
              textAlign: "left",
              letterSpacing: "0.25px",
              textTransform: "uppercase",
              _hover: {
                textDecoration: 'none',
                color: 'primaryGreen.800'
              },
              dangerouslySetInnerHTML: {
                __html: navItem.name
              }
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverContent */.yk, {
          border: 0,
          boxShadow: "xl",
          bg: "baseWhite",
          p: 4,
          rounded: "xl",
          minW: "sm",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
            children: navItem.children.map(child => /*#__PURE__*/(0,jsx_runtime.jsx)(Desktop, _objectSpread({}, child), child.name))
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: navItem.href,
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
          target: navItem.target,
          whiteSpace: "nowrap",
          color: "baseNeutral.700",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.875rem",
          letterSpacing: "0.25px",
          textTransform: "uppercase",
          _hover: {
            textDecoration: 'none',
            color: 'primaryGreen.800'
          } // href={navItem.href}
          ,
          dangerouslySetInnerHTML: {
            __html: navItem.name
          }
        })
      })
    }, navItem.name))
  });
};

/* harmony default export */ var Menu_Desktop = (Desktop_Desktop);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/index.esm.js
var color_mode_dist_index_esm = __webpack_require__(8395);
;// CONCATENATED MODULE: ./src/components/MenuItem/Mobile.tsx






const MobileItem = _ref => {
  let {
    name,
    title,
    href,
    target,
    children
  } = _ref;
  const {
    isOpen,
    onToggle
  } = (0,index_esm/* useDisclosure */.qY)();

  const handleToggle = () => {
    if (children) {
      onToggle();
    }
  };

  const hasChildren = children && children.length > 0;
  return hasChildren ? /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
    spacing: 4,
    p: "m",
    py: "s",
    className: "menu-item-mobile",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
      py: 2,
      title: title,
      justify: "space-between",
      align: "center",
      _hover: {
        textDecoration: 'none'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
        title: title,
        target: target,
        fontFamily: "Montserrat-SemiBold",
        color: "baseNeutral.700",
        href: href,
        dangerouslySetInnerHTML: {
          __html: name
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
        as: icons_dist_index_esm/* ChevronRightIcon */.XC,
        color: "baseNeutral.700",
        transition: "all .25s ease-in-out",
        transform: isOpen ? 'rotate(90deg)' : '',
        w: 6,
        h: 6,
        onClick: handleToggle
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
      mt: "0 !important",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(transition_dist_index_esm/* Collapse */.UO, {
        in: isOpen,
        animateOpacity: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
          pl: 4,
          borderLeft: 1,
          borderStyle: "solid",
          borderColor: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)('gray.200', 'gray.700'),
          align: "start",
          children: children.map(child => /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
            href: child.href,
            title: child.title,
            target: child.target,
            py: 2,
            dangerouslySetInnerHTML: {
              __html: child.name
            }
          }, child.name))
        })
      })
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
    p: "m",
    py: "s",
    className: "menu-item-mobile",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
      title: title,
      justify: "space-between",
      align: "center",
      _hover: {
        textDecoration: 'none'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
        title: title,
        target: target,
        py: 2,
        fontFamily: "Montserrat-SemiBold",
        color: "baseNeutral.700",
        href: href,
        dangerouslySetInnerHTML: {
          __html: name
        }
      }, name)
    })
  });
};

/* harmony default export */ var Mobile = (MobileItem);
;// CONCATENATED MODULE: ./src/components/Menu/Mobile.tsx


function Mobile_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Mobile_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Mobile_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Mobile_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const Mobile_Mobile = _ref => {
  let {
    items
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
    bg: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)('baseWhite', 'gray.800'),
    textTransform: "uppercase",
    fontSize: "0.875rem",
    children: items.map(navItem => /*#__PURE__*/(0,jsx_runtime.jsx)(Mobile, Mobile_objectSpread({}, navItem), navItem.name))
  });
};

/* harmony default export */ var Menu_Mobile = (Mobile_Mobile);
;// CONCATENATED MODULE: ./src/components/Header/index.tsx








const Header = _ref => {
  let {
    href,
    title,
    menuItems
  } = _ref;
  const {
    isOpen,
    onToggle
  } = (0,index_esm/* useDisclosure */.qY)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
    className: "header-container",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
      bg: "baseWhite",
      color: "baseNeutral.700",
      py: {
        base: 'xs',
        md: 'xl'
      },
      px: {
        base: 'm',
        md: 'xxl3'
      },
      borderBottom: 0,
      textAlign: "center",
      boxShadow: "0 2px 4px 0px rgba(0, 0, 0, 0.08)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
        display: {
          base: 'block',
          md: 'none'
        },
        flex: "auto",
        ml: {
          base: -2
        },
        float: "left",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
          onClick: onToggle,
          icon: isOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(icons_dist_index_esm/* CloseIcon */.Tw, {
            w: 3,
            h: 3
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(icons_dist_index_esm/* HamburgerIcon */.Uq, {
            w: 5,
            h: 5
          }),
          variant: "ghost",
          "aria-label": "Toggle Navigation"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        flex: {
          base: 1
        },
        justify: {
          base: 'center',
          md: 'start'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Logo, {
          href: href,
          title: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_OrganizationSchema, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Spacer */.LZ, {
            display: {
              base: 'none',
              md: 'flex'
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
            ml: 10,
            display: {
              base: 'none',
              md: 'flex'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Menu_Desktop, {
              items: menuItems
            })
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
      display: {
        base: 'block',
        md: 'none'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(transition_dist_index_esm/* Collapse */.UO, {
        in: isOpen,
        animateOpacity: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Menu_Mobile, {
          items: menuItems
        })
      })
    })]
  });
};

/* harmony default export */ var components_Header = (Header);

/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7942)


/***/ })

}]);